import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import type { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface WeeklyScheduleState {
  timezone: string;
  schedule: Condition.WeeklyScheduleData;
}

export const WEEKLY_SCHEDULE_CHAT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<WeeklyScheduleState>>,
): ConditionType<WeeklyScheduleState, Condition.WeeklySchedule> => ({
  name: CONDITION_NAMES[Condition.WEEKLY_SCHEDULE],
  description(state) {
    const enabled = Object.entries(state.schedule)
      .filter(([, day]) => day?.enabled)
      .map(([name]) => name);
    return enabled.length
      ? `Active on: ${enabled.join(", ")}`
      : "Weekly schedule (no days enabled)";
  },
  Details(props: ConditionTypeDetailsProps<WeeklyScheduleState>) {
    return React.createElement(Details, props);
  },
  empty: { timezone: "America/New_York", schedule: {} },
  fromModel(model) {
    return { timezone: model.timezone, schedule: model.schedule };
  },
  toModel(state) {
    return {
      type: Condition.WEEKLY_SCHEDULE,
      timezone: state.timezone,
      schedule: state.schedule,
    };
  },
  valid(state) {
    return !!state.timezone;
  },
});
